/**
 * Operations Skill Area
 * Lessons focused on workflow optimization, planning, and resource management
 */

export { crisisTriage } from './crisis-triage';
export { opsPlaybookBuilder } from './ops-playbook-builder';
export { inboxTriage } from './inbox-triage';
export { analyzeOptions } from './analyze-options';
export { buildPlans } from './build-plans';
export { monitorFinances } from './monitor-finances';
export { optimizeWorkflows } from './optimize-workflows';
export { automatedOversight } from './automated-oversight';

import { crisisTriage } from './crisis-triage';
import { opsPlaybookBuilder } from './ops-playbook-builder';
import { inboxTriage } from './inbox-triage';
import { analyzeOptions } from './analyze-options';
import { buildPlans } from './build-plans';
import { monitorFinances } from './monitor-finances';
import { optimizeWorkflows } from './optimize-workflows';
import { automatedOversight } from './automated-oversight';
import type { LessonDefinition } from '../types';

export const operationsLessons: LessonDefinition[] = [
  crisisTriage,
  opsPlaybookBuilder,
  inboxTriage,
  analyzeOptions,
  buildPlans,
  monitorFinances,
  optimizeWorkflows,
  automatedOversight,
];
